import { render, staticRenderFns } from "./TagFormPicker.vue?vue&type=template&id=6b438c3a&scoped=true"
import script from "./TagFormPicker.vue?vue&type=script&lang=js"
export * from "./TagFormPicker.vue?vue&type=script&lang=js"
import style0 from "./TagFormPicker.vue?vue&type=style&index=0&id=6b438c3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b438c3a",
  null
  
)

export default component.exports